export default "__VITE_ASSET__DwxbvEwS__"